import { useMemo } from 'react';
import { AdvancedColDef } from './helpers';

interface Props {
  columnHeaderGrouping?: boolean;
  columnDefs: AdvancedColDef[];
}

interface UseColGroup {
  columnDefs: AdvancedColDef[];
}

export const useColGroup = ({ columnDefs, columnHeaderGrouping }: Props): UseColGroup => {
  const groupColumnDefs = useMemo(() => {
    if (columnHeaderGrouping === false) {
      return columnDefs.reduce<AdvancedColDef[]>((acc, columnDef) => {
        if ('children' in columnDef) {
          return [...acc, ...(columnDef.children as AdvancedColDef[])];
        }
        return [...acc, columnDef];
      }, []);
    } else {
      return columnDefs;
    }
  }, [columnDefs, columnHeaderGrouping]);

  return {
    columnDefs: groupColumnDefs,
  };
};
